import createReactComponent from '../createReactComponent';
export default createReactComponent('git-fork', 'IconGitFork', [
  ['path', { d: 'M12 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0', key: 'svg-0' }],
  ['path', { d: 'M7 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0', key: 'svg-1' }],
  ['path', { d: 'M17 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0', key: 'svg-2' }],
  ['path', { d: 'M7 8v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2 -2v-2', key: 'svg-3' }],
  ['path', { d: 'M12 12l0 4', key: 'svg-4' }],
]);
